import TableSelectColumnType from "./TableSelectColumnType";

export default class TableSelectColumnConfig {
    public internalName: string = "";
    public columnType: TableSelectColumnType = TableSelectColumnType.text;
    public label: string = "";
}